import './bootstrap';
import '../css/app.css';
import '../css/add.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCar,faList, faBars, faCirclePlus, faCalendar,
    faArrowRightFromBracket,
    } from '@fortawesome/free-solid-svg-icons'

library.add(faCar, faList, faBars, faCirclePlus, faCalendar, faArrowRightFromBracket)

import AppLayout from '@/Layouts/AppLayout.vue';
import CarLayout from '@/Layouts/CarLayout.vue';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) => {
        const page = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'));

        // Appliquer automatiquement AppLayout si la page ne définit pas explicitement un layout
        page.default.layout = page.default.layout || AppLayout;

        return page;
    },
    //resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .component("font-awesome-icon", FontAwesomeIcon)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
